import { QueryClient } from "@tanstack/react-query";

// Tek paylaşılan react-query client. index.js sağlayıcıya verir; AuthContext
// çıkış/hesap silmede cache'i temizlemek için kullanır (önceki kullanıcının özel
// verisi sonraki kullanıcıya sızmasın).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});
